// extracted by mini-css-extract-plugin
module.exports = {"root":"Style_root__1SbxU","content":"Style_content__1WCsG","titulo":"Style_titulo__pSMrC","descripcion":"Style_descripcion__1jE8I","img":"Style_img__1faCR"};